'use strict';

import CustomAutoscroll from './turbo/CustomAutoscroll';
import DebugBarReloader from './turbo/DebugBarReloader';
import FormActionHandler from './turbo/FormActionHandler';
import GetFormHandler from './turbo/GetFormHandler';
import MissingFrameHandler from './turbo/MissingFrameHandler';

new CustomAutoscroll();
new DebugBarReloader();
new FormActionHandler();
new GetFormHandler();
new MissingFrameHandler();
